import React from 'react';
import { Helmet } from 'react-helmet-async';

import MainLayout from '../../Layout/main';

import Header from '../../Components/header-interna';
import Listagem from './Sections/listagem';

const ListagemBlog: React.FC<any> = ({initialData} : any) => {
    const title = 'Blog';
 
    const breadcrumb = [{
        name: 'Blog',
        slug: 'blog'
    }];
    
    return (
        <>
            <Helmet>
                <title>{title} - Uniexpo</title>
            </Helmet>

            <MainLayout>
                <Header title={title} breadcrumb={breadcrumb} />
                <Listagem initialData={initialData} />
            </ MainLayout>
        </>
    );
};

export default ListagemBlog;
